module.exports = __webpack_public_path__ + "static/banner_bg-60cbed3d96ceed71d1095d446600d245.jpg";